import React, { useEffect } from 'react';
import Button from '../Button/Button';
import Modal from './Modal';
import { connect } from 'react-redux';
import { closeTimer, decrementTimer } from '../../store/actions/timer';
import {LS_OTP_VERIFIED, LS_OTP_VERIFIED_NUMBER, LS_DISABLE_IDENTITY_ATTEST_FAIL} from '../../shared/Constants';

const IdentityProofSessionModal = ({ showModal, timeStarted, togglePopup, closeTimer, decrementTimer }) => {

  useEffect(() => {
    let interval;
    if (timeStarted) {
      interval = setInterval(() => {
        decrementTimer(1000);
      }, 1000)
    }

    return () => {
      clearInterval(interval);
    }
  }, [timeStarted])

  const handleRefresh = () => {
    localStorage.removeItem(LS_OTP_VERIFIED)
    localStorage.removeItem(LS_OTP_VERIFIED_NUMBER)
    localStorage.removeItem(LS_DISABLE_IDENTITY_ATTEST_FAIL)
    window.location.reload();
    closeTimer()
  }
  return <Modal show={showModal} toggle={togglePopup} keyboard={false} backdrop="static">
    <h1>Session Expired!</h1>
    <p>
      Please confirm Identity.
    </p>
    <Button btnType="Search" clicked={handleRefresh}>Please Refresh!</Button>
  </Modal>
}

export const mapStateToProps = state => {
  return {
    user: state.usr.user,
    showModal: state.timer.showIdentityProofPopup,
    timeStarted: state.timer.timeStarted,
  }
}

export const mapDispatchToProps = dispatch => {
  return {
    // fetchUser: () => dispatch(actions.fetchUser()),
    // onUserLogout: () => dispatch(actions.logoutUser()),
    closeTimer: () => dispatch(closeTimer()),
    decrementTimer: (time) => dispatch(decrementTimer(time)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IdentityProofSessionModal);